import React, {Component} from "react"
import {Link} from "gatsby"
import smoothscroll from 'smoothscroll-polyfill';
import tocStyles from './toc.module.css';
import calculatorImg from '../images/calculator.png';
import caretImg from '../images/downCaretOrange.png';
import LessonUtils from "./lessonUtils";

const tocIcons = {
    intro: <i class={"ri-lightbulb-flash-line"}></i>,
    calculator: <i class={"ri-calculator-line"}></i>,
    recap: <i class={"ri-key-2-line"}></i>,
    practice: <i class={"ri-checkbox-multiple-line"}></i>,
    lesson: <i class={"ri-book-open-line"}></i>,
    expand: <i class={"ri-add-box-line"}></i>,
    feedback: <i class={"ri-chat-3-line"}></i>,
    back: <i class={"ri-arrow-left-line"}></i>
}

class TOC extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentSectionRef: 0,
            currentProgressRef: 0,
            currentPercentage: 0,

            mobileToggle: false,
        }
        this.scrollListenerFunction = (() => this.checkProgressPercent());
        this.handleClickTOCClickFunction = ((e) => this.handleClickTOCClick(e));
        this.mobileRef = React.createRef();
        this.mobileDrawerRef = React.createRef();
        this.mobileDrawerContentRef = React.createRef();
    }

    componentDidMount() {
        smoothscroll.polyfill();
        document.addEventListener("scroll", this.scrollListenerFunction);
        document.addEventListener("mousedown", this.handleClickTOCClickFunction);

        // If the first section is a calculator the image height isn't available
        // for the initial hieght calculation so we need to account for it by
        // hand.
        var initialHeight = this.mobileDrawerContentRef.current.clientHeight;
        if (this.props.tocData.sections[0].calculator) {
            initialHeight = Math.max(initialHeight, 32);
        }
        this.mobileDrawerRef.current.style.height =  initialHeight + "px"
    }

    componentWillUnmount() {
        document.removeEventListener("scroll", this.scrollListenerFunction);
        document.removeEventListener("mousedown", this.handleClickTOCClickFunction);
    }

    componentDidUpdate() {
        if (this.mobileDrawerRef.current) {
            if (this.state.mobileToggle) {
                const expandedHeight = Math.min(this.mobileDrawerContentRef.current.clientHeight, 300) + "px"
                this.mobileDrawerRef.current.style.height = expandedHeight;
            } else if (this.mobileDrawerContentRef.current){
                this.mobileDrawerRef.current.style.height = this.mobileDrawerContentRef.current.clientHeight + "px"
            }
        }
    }

    handleClickTOCClick(event) {
        if (this.mobileRef && !this.mobileRef.current.contains(event.target)) {
           this.setState({mobileToggle: false});
       }
    }

    checkProgressPercent() {
        // HACK TO DETECT CARD LESSONS FOR DIFFERENT PROGRESS LOGIC
        if (this.props.tocData.expandAll) {
            this.checkProgressPercentForCards();
            return;
        }

        var top = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0);
        if (top <= 2) {
            this.setState({currentSectionRef: 0});
            return;
        }
        var newCurrentSectionRef = 0;
        var newCurrentSectionRefPos = null;
        var newCurrentProgressRef = 0;
        for (var i = 0; i < this.props.tocData.sections.length; i++) {
            if (!this.props.tocData.sections[i].ref
                || !this.props.tocData.sections[i].ref.current
                || this.props.tocData.sections[i].ref.current.style.display === "none"
                || (this.props.tocData.sections[i].ref.current.style.display === "" && this.props.tocData.sections[i].ref.current.offsetHeight === 0)) {
                continue;
            }
            var sectionPos = this.props.tocData.sections[i].ref.current.getBoundingClientRect().top - window.innerHeight + 120;

            if (sectionPos <= 0 && (newCurrentSectionRefPos === null || newCurrentSectionRefPos < sectionPos)) {
                newCurrentSectionRef = i;
                newCurrentSectionRefPos = sectionPos;
                newCurrentProgressRef++;
            }
        }
        newCurrentProgressRef = Math.max(newCurrentProgressRef, this.state.currentProgressRef);
        this.setState({
            currentSectionRef: newCurrentSectionRef,
            currentProgressRef: newCurrentProgressRef,
            currentPercentage: (newCurrentProgressRef)*100/this.props.tocData.sections.length
        }, () => this.props.updateProgressPercentage(this.state.currentPercentage))
    }

    checkProgressPercentForCards() {
        var top = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0);
        if (top <= 2) {
            this.setState({currentSectionRef: 0});
            return;
        }
        var newCurrentSectionRef = 0;
        var newCurrentSectionRefPos = null;
        var newCurrentProgressRef = 0;
        for (var i = 0; i < this.props.tocData.sections.length; i++) {
            if (!this.props.tocData.sections[i].lessonRef
                || !this.props.tocData.sections[i].lessonRef.current
                || !this.props.tocData.sections[i].lessonRef.current.getCardRef()
                || !this.props.tocData.sections[i].lessonRef.current.getCardRef().current
                || !this.props.tocData.sections[i].lessonRef.current.hasEverBeenOpened()) {
                continue;
            }
            var sectionPos = this.props.tocData.sections[i].lessonRef.current.getCardRef().current.getBoundingClientRect().top - window.innerHeight + 120;

            if (sectionPos <= 0 && (newCurrentSectionRefPos === null || newCurrentSectionRefPos < sectionPos)) {
                newCurrentSectionRef = i;
                newCurrentSectionRefPos = sectionPos;
                newCurrentProgressRef++;
            }
        }
        newCurrentProgressRef = Math.max(newCurrentProgressRef, this.state.currentProgressRef);
        this.setState({
            currentSectionRef: newCurrentSectionRef,
            currentProgressRef: newCurrentProgressRef,
            currentPercentage: (newCurrentProgressRef)*100/this.props.tocData.sections.length
        }, () => this.props.updateProgressPercentage(this.state.currentPercentage))
    }

    expandUnlockAndScroll(section) {
        if (section.lessonRef) {
            section.lessonRef.current.expand();
            LessonUtils.scrollToRef(section.lessonRef.current.getCardRef());
        } else {
            section.unlockAndScroll();
        }
    }

    getSections() {
        var links = [];
        for (var i = 0; i < this.props.tocData.sections.length; i++) {
            let section = this.props.tocData.sections[i];
            let icon = tocIcons[section.icon] ? tocIcons[section.icon] : tocIcons["lesson"];
            links.push(
                <div key={"tocsection"+i} className={i === this.state.currentSectionRef ? tocStyles.currentSection : tocStyles.section}>
                        <button onClick={() => this.expandUnlockAndScroll(section)} style={{width:"100%"}}>
                            <div style={{display:"grid", gridTemplateColumns:"auto 1fr", gridGap:"5px", justifyItems:"start", alignItems:"start"}}>
                                <div>{icon}</div>
                                <div><p style={{whiteSpace:"normal", paddingTop:"1px"}}>{section.title}</p></div>
                            </div>
                        </button>
                </div>
            );
        }
        links.push(<hr style={{backgroundColor:"var(--color-Border)", margin: "10px auto", width:"100%"}}></hr>);
        if (this.props.tocData.expandAll) {
            links.push(
                <div key={"expandall"} className={tocStyles.section} style={{whiteSpace:"nowrap"}}>
                        <button onClick={(e) => {e.stopPropagation(); this.props.tocData.expandAll()}} style={{verticalAlign:"middle"}}>
                            <div style={{display:"grid", gridTemplateColumns:"auto 1fr", gridGap:"5px", justifyItems:"start", alignItems:"start"}}>
                                <div>{tocIcons["expand"]}</div>
                                <div><p style={{whiteSpace:"normal", paddingTop:"1px"}}>Expand all</p></div>
                            </div>
                        </button>
                </div>
            )
        }
        links.push(
            <div key={"backtolesson"} className={tocStyles.section} style={{whiteSpace:"nowrap"}}>
                <Link to="/lessons">
                    <button style={{verticalAlign:"middle"}}>
                        <div style={{display:"grid", gridTemplateColumns:"auto 1fr", gridGap:"5px", justifyItems:"start", alignItems:"start"}}>
                            <div>{tocIcons["back"]}</div>
                            <div><p style={{whiteSpace:"normal", paddingTop:"1px"}}>Back to all math lessons</p></div>
                        </div>
                    </button>
                </Link>
            </div>
        )
        return links;
    }

    getMobileSections() {
        var links = [];
        for (var i = 0; i < this.props.tocData.sections.length; i++) {
            let section = this.props.tocData.sections[i];
            let icon = tocIcons[section.icon] ? tocIcons[section.icon] : tocIcons["lesson"];
            links.push(
                <div key={"tocmobilesection"+i} className={i === this.state.currentSectionRef ? tocStyles.currentSection : tocStyles.section} style={{whiteSpace:"nowrap"}}>
                        <button onClick={(e) => {e.stopPropagation(); this.setState({mobileToggle:false}, () => this.expandUnlockAndScroll(section));}} style={{verticalAlign:"middle"}}>
                            <div style={{display:"grid", gridTemplateColumns:"auto 1fr", gridGap:"5px", justifyItems:"start", alignItems:"start"}}>
                                <div>{icon}</div>
                                <div><p style={{whiteSpace:"normal", paddingTop:"1px"}}>{section.title}</p></div>
                            </div>
                        </button>
                </div>
            );
        }

        links.push(<hr style={{backgroundColor:"var(--color-Border)", margin: "10px auto", width:"100%"}}></hr>);
        if (this.props.tocData.expandAll) {
            links.push(
                <div key={"expandall"} className={tocStyles.section} style={{whiteSpace:"nowrap"}}>
                        <button onClick={(e) => {e.stopPropagation(); this.setState({mobileToggle:false}); this.props.tocData.expandAll()}} style={{verticalAlign:"middle"}}>
                            <div style={{display:"grid", gridTemplateColumns:"auto 1fr", gridGap:"5px", justifyItems:"start", alignItems:"start"}}>
                                <div>{tocIcons["expand"]}</div>
                                <div><p style={{whiteSpace:"normal", paddingTop:"1px"}}>Expand all</p></div>
                            </div>
                        </button>
                </div>
            )
        }
        links.push(
            <div key={"feedbacklinkmobile"} className={tocStyles.section} style={{whiteSpace:"nowrap"}}>
                    <button onClick={(e) => {e.stopPropagation(); this.setState({mobileToggle:false}, () => this.props.toggleMobileFeedback());}} style={{verticalAlign:"middle"}}>
                        <div style={{display:"grid", gridTemplateColumns:"auto 1fr", gridGap:"5px", justifyItems:"start", alignItems:"start"}}>
                            <div>{tocIcons["feedback"]}</div>
                            <div><p style={{whiteSpace:"normal", paddingTop:"1px"}}>Leave Feedback</p></div>
                        </div>
                    </button>
            </div>
        )
        links.push(
            <div key={"backtolessonmobile"} className={tocStyles.section} style={{whiteSpace:"nowrap", paddingBottom:"20px"}}>
                <Link to="/lessons">
                    <button style={{verticalAlign:"middle"}}>
                        <div style={{display:"grid", gridTemplateColumns:"auto 1fr", gridGap:"5px", justifyItems:"start", alignItems:"start"}}>
                            <div>{tocIcons["back"]}</div>
                            <div><p style={{whiteSpace:"normal", paddingTop:"1px"}}>Back to all math lessons</p></div>
                        </div>
                    </button>
                </Link>
            </div>
        )

        return links;
    }

    render() {
        const percentageString = this.state.currentPercentage + "%";
        const mobileTOCScroll = this.state.mobileToggle ? "auto" : "hidden";
        const mobilePadding = this.state.mobileToggle ? "17px 0px 0px" : "17px 0px 15px";
        const currentSection = this.props.tocData.sections[this.state.currentSectionRef];
        const currentSectionIcon = tocIcons[currentSection.icon] ? tocIcons[currentSection.icon] : tocIcons["lesson"];
        return (
            <>
                <div className={tocStyles.desktop} style={{backgroundColor:"transparent", width:"100%", height:"100%"}}>
                    <div className={tocStyles.tocContainer}>
                        <div className={tocStyles.toc}>
                            <div style={{marginTop:"2rem"}}><h4 style={{margin:0, padding:"0 20px"}}>QUICK LINKS</h4></div>
                            <div style={{marginTop:"10px", padding:"0 20px", paddingBottom:"20px", overflowY:"auto", maxHeight:"45vh"}}>
                                {this.getSections()}
                            </div>
                        </div>
                        <div style={{position:"absolute", bottom:0, backgroundColor:"var(--color-Border)", height:"8px", width:"100%", transition:"0.5s all ease"}}></div>
                        <div style={{position:"absolute", bottom:0, backgroundColor:"var(--color-Sonic)", height:"8px", width:percentageString, transition:"0.5s all ease"}}></div>
                    </div>
                </div>
                <div ref={this.mobileRef} className={tocStyles.mobile} style={{width:"100%", margin:0, padding:mobilePadding, height:"auto", maxHeight:"40vh"}}>
                    <div ref={this.mobileDrawerRef} className={tocStyles.tocMobile + (this.state.mobileToggle ? (" " + tocStyles.toggled) : "")} onClick={() => this.setState({mobileToggle: true})} style={{width: '90%', margin:"auto", height:"0", overflowY:"hidden"}}>
                        <div ref={this.mobileDrawerContentRef} className={this.state.mobileToggle ? "" : tocStyles.currentSection}>
                            {this.state.mobileToggle
                                ?
                                    <div style={{height:"max-content"}}>
                                        <div style={{height:"auto", maxHeight:"30vh", overflowY: mobileTOCScroll}}>
                                            {this.getMobileSections()}
                                        </div>
                                        <div style={{width:"100%", textAlign:"center", padding: ".5rem 0 1rem"}} onClick={(e) => {e.stopPropagation(); this.setState({mobileToggle: false})}}>
                                            <img src={caretImg} style={{display:"block", transform:"scaleY(-1)", margin: "0 auto"}}/>
                                        </div>
                                    </div>
                                :
                                    <div>
                                        <div style={{display:"inline-block", width:"85%"}}>
                                            <div style={{display:"grid", gridTemplateColumns:"auto 1fr", gridGap:"5px", justifyItems:"start", alignItems:"start", color:"var(--color-Sonic-Text)"}}>
                                                <div>{currentSectionIcon}</div>
                                                <div><p className={tocStyles.toc} style={{whiteSpace:"normal", paddingTop:"1px"}}>{currentSection.title}</p></div>
                                            </div>
                                        </div>
                                        <div style={{display:"inline-block", width:"15%"}}>
                                            <div style={{position:"absolute", top:0, right:18, height:"100%"}}>
                                                <div style={{height:"100%", display:"inline-block", verticalAlign:"middle"}}></div>
                                                <img src={caretImg} style={{verticalAlign:"middle", display:"inline-block"}} />
                                            </div>
                                        </div>
                                    </div>
                            }
                        </div>
                    </div>
                    <div style={{position:"absolute", bottom:0, backgroundColor:"var(--color-Border)", height:"2px", width:"100%", transition:"0.5s all ease"}}></div>
                    <div style={{position:"absolute", bottom:0, backgroundColor:"var(--color-Sonic)", height:"2px", width:percentageString, transition:"0.5s all ease"}}></div>
                </div>
            </>
        )
    }
}

export default TOC;
